import { jsx as _jsx } from "react/jsx-runtime";
import Header from '../../../../app/main/headers/header';
import { SearchInput } from '../../../infra/ui/search-input';
export var BrandSearchHeader = function (_a) {
    var onSearchChange = _a.onSearchChange, searchTerm = _a.searchTerm;
    return (_jsx(Header, { heading: "Brands", type: "brand", button: "Add brand", link: "/admin/brands/add", children: _jsx("div", { className: "c-header-primary__components", children: _jsx(SearchInput, { className: "c-search-input-component", name: "search-input", placeholder: "Search brands...", showIcon: true, initialValue: searchTerm, setSearchTerm: onSearchChange }) }) }));
};
